import React, { memo, useState, useRef, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { filterSectionPropTypes } from 'core/propTypes/filterPropTypes';
import FilterOption from './FilterOption';

const formatSectionName = (name) => {
    if (name === 'product_navbar') {
        return 'Tendencias';
    }
    if (name === 'project_scale') {
        return 'Tamaño de la obra'; // Replace project_scale with Tamaño de la obra
    }
    return name.replace(/[-_]/g, ' ').replace(/\b\w/g, char => char.toUpperCase()).toLowerCase().replace(/^\w/, char => char.toUpperCase());
};

const FilterSection = memo(({ section, onFilterChange, defaultOpen = false }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const [maxHeight, setMaxHeight] = useState(defaultOpen ? 'none' : '0px');
    const contentRef = useRef(null);

    const toggleSection = useCallback(() => {
        setIsOpen(prev => !prev);
    }, []);

    useEffect(() => {
        if (contentRef.current) {
            setMaxHeight(isOpen ? `${contentRef.current.scrollHeight}px` : '0px');
        }
    }, [isOpen]);

    useEffect(() => {
        if (section.defaultOpen) {
            setIsOpen(true);
        }
    }, [section.defaultOpen]);

    return (
        <div className="ltn__menu-widget">
            <button className="filter-section-toggle pb-0" onClick={toggleSection}>
                <a to="#"> {formatSectionName(section.name)} </a>
                <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'}`} />
            </button>
            <div
                className="filter-section-content"
                style={{ maxHeight }}
                ref={contentRef}
            >
                <ul className="ps-0">
                    {section.options.map((option) => (
                        <FilterOption
                            key={option.value}
                            option={option}
                            onOptionChange={(checked) => onFilterChange(section.name, option.value, checked)}
                            type={section.type}
                        />
                    ))}
                </ul>
            </div>
        </div>
    );
});

FilterSection.propTypes = filterSectionPropTypes;

export default FilterSection;